<template>
  <div>
    <div class='edit-event'>
      <div class='centered back link'>
        <span @click='back'>&#8592; К списку мероприятий</span>
      </div>
      <div class="event" v-if="eventObject">
        <div class="event-header-wrapper" v-bind:style="photoContainerStyle">
          <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDeleteEventPhoto" v-if="eventObject.photo || this.base64photo"/>
          <div class="event-header translucent-wrapper">
            <b-field>
                <b-input placeholder="Заголовок" required v-model="eventObject.title" @change="handleUpdate"></b-input>
            </b-field>
            <b-field>
                <b-input placeholder="Назавние мероприятия" required v-model="eventObject.description" @change="handleUpdate"></b-input>
            </b-field>
            <div class="centered">
              <span class="button-wrapper" @click="handleLoadPhoto" v-if="!eventObject.photo">
                <a class="button is-info">+</a>Добавить фото
              </span>
            </div>
            <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
          </div>
        </div>
        <div class='columns event-description is-multiline'>
          <div class='column is-one-quarter'>
            <b-field label='Дата мероприятия' class='start-date'>
              <el-date-picker
                type='datetime'
                :editable="false"
                @change='dateChanged'
                v-model='date'
                placeholder='Выберите дату и время'>
              </el-date-picker>
            </b-field>
          </div>
          <div class='column is-one-quarter'>
            <b-field label='Дата окончания регистрации' class='end-date'>
              <el-date-picker
                type='datetime'
                :editable="false"
                @change='dateChanged'
                placeholder='Выберите дату и время'
                v-model='registrationEndDate'>
              </el-date-picker>
            </b-field>
          </div>
          <div class="column is-one-quarter">
            <b-field label="Адрес проведения (без города)">
                <b-input placeholder="Введите адрес" v-model="eventObject.address" @change="handleUpdateAddress"></b-input>
            </b-field>
          </div>
          <div class="column is-one-quarter">
            <b-field label="Кому подходит">
                <b-input placeholder="Опишите кому полезно мероприятие" v-model="eventObject.toWhom" @change="handleUpdate"></b-input>
            </b-field>
          </div>
          <div class="column is-one-quarter">
            <b-field label="Email ответственного за мероприятие (через запятую)">
                <b-input placeholder="Введите email" required v-model="eventObject.email" @change="handleUpdate"></b-input>
            </b-field>
          </div>
          <div class="column is-one-quarter">
            <b-field label="Ссылка">
                <b-input placeholder="Ссылка" v-model="eventObject.link" @change="handleUpdate"></b-input>
            </b-field>
          </div>
        </div>
        <div class='map-container' v-if='center'>
          <h2 class='has-text-centered'>Укажите адрес на карте</h2>
          <gmap-map
            :center='center'
            :zoom='15'
            :options='{scrollwheel: false}'
            style='height: 350px'
            @click='selectAddress'
          >
            <gmap-marker
             :key='index'
             v-for='(m, index) in markers'
             :position='m.position'
            ></gmap-marker>
          </gmap-map>
          <div class='centered'><div class='button delete-pin' @click='deletePin'>Удалить метку</div></div>
        </div>
        <div class="talks">
          <b-field label="Обсудим">
             <Editor :editorToolbar='customToolbar' v-model='newInformation' id='new-information' placeholder='Напишите, что узнают посетители'/>
          </b-field>
          <b-field label="Чем полезно для меня?">
            <Editor :editorToolbar='customToolbar' v-model='reason' id='reason' placeholder=''/>
          </b-field>
          <div class="box">
            <b-field label="Партнеры (верхний блок)">
              <multiselect
                v-model='eventObject.topPartners'
                placeholder='Выберите партнеров'
                :multiple='true'
                trackBy="id"
                :custom-label='customLabel'
                selectLabel=''
                deselectLabel=''
                :options='partners'>
              </multiselect>
            </b-field>
            <b-input v-model="eventObject.topPartnersTitle" @change="handleUpdate" />
          </div>
          <div class="box">
            <b-field label="Партнеры (нижний блок)">
              <multiselect
                v-model='eventObject.bottomPartners'
                placeholder='Выберите партнеров'
                :multiple='true'
                trackBy="id"
                :custom-label='customLabel'
                selectLabel=''
                deselectLabel=''
                :options='partners'>
              </multiselect>
            </b-field>
            <b-input v-model="eventObject.bottomPartnersTitle" @change="handleUpdate" />
          </div>
          <b-field label="Услуги">
            <multiselect
              v-model='eventObject.services'
              placeholder='Выберите услуги'
              :multiple='true'
              trackBy="id"
              :custom-label='customLabel'
              selectLabel=''
              deselectLabel=''
              :options='availableServices'>
            </multiselect>
          </b-field>
        </div>
        <div class='event-items'>
          <EventItem v-for='item in eventObject.eventItems' :key='item.id' :item='item'/>
        </div>
        <div class="centered">
          <span class="button-wrapper" @click="handleAddEventItem">
            <a class="button is-info">+</a>Добавить пункт программы
          </span>
        </div>
        <div class='add-summary'>
          <div class='centered'>
            <span class='button-wrapper' @click='toggleSummary'>
              <a class='button is-info'>+</a>Добавить фотоотчет с описанием
            </span>
          </div>
          <div class="summary-content has-text-centered" v-if="eventObject.showSummary">
            <span class="link" @click="handleLoadSummaryPhoto">Загрузить фото</span>
            <input type="file" @change='loadSummaryPhotoHandler' hidden ref="loadSummaryPhotoButton"/>
            <swiper :options="swiperOption" v-if="eventObject.photos.length">
              <swiper-slide  v-for="photo in eventObject.photos" :key="photo">
                <div class="centered">
                  <img :src='"/upload/photos/" + photo' v-if="typeof photo === 'string'"/>
                  <img :src='photo.base64photo' v-else />
                  <a class="button is-danger delete-summary-photo" @click="deleteSummaryPhoto(photo)">
                    Удалить
                  </a>
                </div>
              </swiper-slide>
              <div class='swiper-pagination' slot='pagination'></div>
              <div class='swiper-button-prev' slot='button-prev'></div>
              <div class='swiper-button-next' slot='button-next'></div>
            </swiper>
            <b-field label='Краткий обзор мероприятия' class='summary-text'>
              <Editor :editorToolbar='customToolbar' v-model='summary' id='summary' placeholder='Введите текст'/>
            </b-field>
          </div>
        </div>
      </div>
      <div class="save-content-button centered" v-if="eventObject">
        <button class="button save-content" @click="handleSaveEvent()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
    </div>
    <div class="columns" v-if="eventObject">
      <div class="column delete-service centered is-one-third" @click="deleteEvent(event)" v-if="!event.isNew">
        Удалить
      </div>
      <div class='column hide'>
        <b-switch v-model='eventObject.publishLater'>Опубликовать позже</b-switch>
        <el-date-picker
          type='datetime'
          :editable="false"
          @change='dateChanged'
          v-model='publishDate'
          placeholder='Дата публикации на сайте'>
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import router from '../../router'
import deepcopy from 'deepcopy'
import EventItem from 'components/Events/EventItem'
import Multiselect from 'vue-multiselect'
import uuidv4 from 'uuid/v4'
import { VueEditor as Editor } from 'vue2-editor'
import axios from 'axios'

moment.locale('ru')

export default {
  name: 'EditEvent',
  data () {
    return {
      updateTimer: 0,
      geocoderTimer: 0,
      speakerId: null,
      date: null,
      registrationEndDate: null,
      selectedServices: null,
      publishDate: null,
      center: null,
      markers: [],
      newInformation: '',
      reason: '',
      summary: '',
      disabled: false,
      swiperOption: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        autoHeight: false
      },
      base64photo: '',
      customToolbar: [
        ['bold', 'italic', 'underline', 'link']
      ]
    }
  },
  computed: {
    ...mapState(['event', 'services', 'eventCity', 'partners']),
    photoContainerStyle () {
      return this.eventObject.photo || this.base64photo
      ? {background: !this.base64photo.length ? `url(/upload/photos/${this.eventObject.photo})` : `url(${this.base64photo})`}
      : {background: ''}
    },
    availableServices () {
      return this.services.filter(s => {
        return !this.eventObject.services.find(service => service.id === s.id)
      })
    },
    eventObject () {
      if (this.event) {
        this.base64photo = ''
        this.date = this.event.date
        this.publishDate = this.event.publishDate
        this.registrationEndDate = this.event.registrationEndDate
        this.newInformation = this.event.newInformation
        this.reason = this.event.reason
        this.summary = this.event.summary
        if (this.event.location) {
          const point = this.event.location.split(',')
          const position = {
            lat: parseFloat(point[0]), lng: parseFloat(point[1])
          }
          this.center = position
          this.markers.push({
            position: position
          })
        } else {
          this.getAddress()
        }
        return deepcopy(this.event)
      } else if (this.$route.params.id === 'new') {
        router.push('/events/list')
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions(['getEvent', 'updateEvent', 'loadEventPhoto',
      'deleteEventPhoto', 'addEventItem', 'getSortedServices',
      'deleteEvent', 'loadSummaryPhoto', 'deleteSummaryPhoto',
      'addSummaryPhoto', 'saveEvent', 'getPartners']),
    back () {
      router.go(-1)
    },
    handleSaveEvent () {
      this.disabled = true
      this.eventObject.reason = this.eventObject.reason === '<p><br></p>' ? null : this.eventObject.reason
      this.eventObject.newInformation = this.eventObject.newInformation === '<p><br></p>' ? null : this.eventObject.newInformation
      this.eventObject.summary = this.eventObject.summary === '<p><br></p>' ? null : this.eventObject.summary
      this.saveEvent(this.eventObject)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    handleLoadPhoto () {
      if (!this.eventObject.photo) {
        this.$refs.loadPhotoButton.click()
      }
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (e) => {
        this.base64photo = e.target.result
        this.$forceUpdate()
      }
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      this.eventObject.newPhoto = formData
    },
    handleDeleteEventPhoto () {
      this.base64photo = null
      this.eventObject.newPhoto = null
      this.eventObject.photo = ''
      this.handleUpdate()
    },
    dateChanged (e) {
      this.eventObject.date = this.date
      this.eventObject.publishDate = this.publishDate
      this.eventObject.registrationEndDate = this.registrationEndDate
      this.updateEvent(this.eventObject)
    },
    customLabel (option) {
      return `${option.title}`
    },
    handleLoadSummaryPhoto () {
      this.$refs.loadSummaryPhotoButton.click()
    },
    loadSummaryPhotoHandler (e) {
      const reader = new FileReader()
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (e) => {
        this.addSummaryPhoto([ ...this.eventObject.photos, {
          data: formData,
          base64photo: e.target.result
        }])
      }
    },
    toggleSummary () {
      this.eventObject.showSummary = !this.eventObject.showSummary
      this.handleUpdate()
    },
    selectAddress (data) {
      this.eventObject.location = `${data.latLng.lat()}, ${data.latLng.lng()}`
      this.updateEvent(this.eventObject)
      this.markers = []
      const position = { lat: data.latLng.lat(), lng: data.latLng.lng() }
      this.center = position
      this.markers.push({
        position
      })
    },
    handleAddEventItem () {
      this.addEventItem({
        id: uuidv4(),
        event_id: this.eventObject.id
      })
    },
    handleUpdate () {
      this.updateEvent(this.eventObject)
    },
    handleUpdateAddress () {
      this.handleUpdate()
      this.getAddress()
    },
    deletePin () {
      this.markers = []
      this.eventObject.location = ''
      this.getAddress('')
    },
    getAddress () {
      clearTimeout(this.geocoderTimer)
      this.geocoderTimer = setTimeout(() => {
        const axiosInstance = axios.create()
        const place = encodeURIComponent(`${this.eventObject.eventCity.name} ${this.eventObject.address || ''}`)
        axiosInstance.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${place}&key=AIzaSyC36JGZn_Nl3Go2QyT9PQdnT8uACjbrSdE`)
        .then(({ data }) => {
          if (data.results[0]) {
            this.center = data.results[0].geometry.location
            this.selectAddress({
              latLng: {
                lat: () => this.center.lat,
                lng: () => this.center.lng
              }
            })
          }
        })
      }, 1000)
    }
  },
  created () {
    this.getSortedServices()
    this.getPartners()
    const id = this.$route.params.id
    if (!this.event || (!this.event.isNew && id !== this.event.id)) {
      this.getEvent(id)
    }
    this.center = {
      lat: 56.83779946755993,
      lng: 60.59916973114014
    }
  },
  watch: {
    reason (val) {
      this.eventObject.reason = val
      this.updateEvent(this.eventObject)
    },
    newInformation (val) {
      this.eventObject.newInformation = val
      this.updateEvent(this.eventObject)
    },
    summary (val) {
      this.eventObject.summary = val
      this.updateEvent(this.eventObject)
    }
  },
  components: { EventItem, Multiselect, VueGoogleMaps, Editor }
}
</script>

<style scoped>
.back {
  padding: 30px;
  font-size: 16px;
}
.event-header-wrapper {
  position: relative;
  padding: 20px;
}
.delete-icon {
  top: 20px;
  right: 20px;
  width: 30px;
}
.back span {
  cursor: pointer;
}
.edit-event {
  max-width: 1100px;
  margin: 0 auto;
}
.event-header {
  max-width: 700px;
  margin: 0 auto;
  padding: 50px;
}
.talks {
  max-width: 700px;
  margin: 15px auto;
}
.event-description {
  padding: 30px;
  background: #eeeeee;
  margin: 0;
}
.el-date-editor {
  width: 100%;
}
.event-items {
  margin: 20px 0;
}
.end-date,
.start-date {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.hide {
  background: #a8c6fa;
}
.hide .el-input {
  width: 225px;
  margin: 0 10px 0;
}
.delete-service {
  padding: 18px;
}
h2.has-text-centered {
  margin: 45px 0 5px 0;
}
.add-summary {
  margin: 0 0 30px;
}
.summary-text {
  max-width: 500px;
  margin: 0 auto;
}
.summary-content {
  margin: 5px 0 45px;
}
.summary-content .link {
  display: inline-block;
  margin: 10px 0;
}
.summary-photo {
  flex-direction: column;
}
.delete-summary-photo {
  margin: 10px 0;
}
</style>

<style>
.edit-event .el-time-panel {
  width: 110px;
}
.edit-event .ql-editor {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// EditEvent.vue?c6a806a0